import { useState } from 'react';
import { Box, FormControl } from '@mui/material';
import DropdownInput from '../../../components/selector/DropdownInput';
import { filterUndefined } from '../../../utils/FilterUndefinedObject';
import './SoundEffectSetting.scss';

const soundEffectOptions = [
  {
    id: true, name: 'On',
  },
  {
    id: false, name: 'Off',
  },
];

const defaultProps = {
  profile: {},
  onChangeCallback: () => {},
  attributeName: '',
};

export default function SoundEffectSetting(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { profile, onChangeCallback, attributeName } = mergedProps;
  const [soundEffect, setSoundEffect] = useState(profile[attributeName]);
  return (
    <Box display='flex' className='sound-effect-settings' data-test={`sound-effect-settings-container-${attributeName}`}>
      <FormControl variant='outlined'>
        <DropdownInput
          dropdownValues={soundEffectOptions}
          label='Sound Effects'
          labelVariant='h6'
          value={soundEffect}
          onChange={(e) => {
            setSoundEffect(e.target.value);
            onChangeCallback(e.target.value);
          }}
          className='sound-effect-dropdown-select'
          data-test='sound-effect-dropdown-select'
        />
      </FormControl>
    </Box>
  );
}
